export default __webpack_public_path__ + "static/media/rising.cad86e8b.png";